<justifi-card-form
	#justifiElem
	single-line
	validation-mode="onSubmit"
	(ready)="emitReady()"
></justifi-card-form>
